/** @typedef {{ id: string, type: string, content: string, display?: 'inline' | 'block' }} CmsSection */

export function section(id, type, content, opts = {}) {
  return {
    id,
    type,
    content,
    display: opts.display || "block",
    ...opts,
  };
}

export function inlineSection(id, type, content) {
  return section(id, type, content, { display: "inline" });
}

export function getSection(page, id) {
  return page?.sections?.find((s) => s.id === id);
}

export function cmsText(page, id, fallback = "") {
  const c = getSection(page, id)?.content;
  return (c != null && String(c).trim()) || fallback;
}

export function cmsJson(page, id, fallback) {
  const raw = getSection(page, id)?.content;
  if (!raw) return fallback;
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function blockSections(page) {
  return (page?.sections ?? []).filter((s) => s.display !== "inline");
}

export function inlineLabels(page, fallback = {}) {
  return { ...fallback, ...cmsJson(page, "labels", {}) };
}
